module.exports = __webpack_public_path__ + "static/media/meetups_carousel.296bc44a.jpg";